/**
 * @fileoverview Colored tags component for displaying tag items in the companies table
 * @active CONFIRMED - This component is actively used in the application
 * 
 * This component renders a collection of colored tag items with consistent styling.
 * It's used for displaying various tag-based data like sectors, industries, customer types, etc.
 * 
 * @see {@link src/components/companies/companiesList/newCompaniesList/companiesTable/companyInfoTable/CompaniesInfoTableRow.tsx} - Parent row component
 * @see {@link src/components/companies/companiesList/newCompaniesList/companiesTable/shared/coloredTags/ColoredItem.tsx} - Individual tag item component
 * @see {@link src/components/companies/companiesList/newCompaniesList/companiesTable/shared/RowText.tsx} - Text display component
 * @see {@link src/components/companies/companiesList/companiesListComponents/tableMain/TableElements.jsx} - Legacy implementation (deprecated)
 */

import { Flex } from "@chakra-ui/react";

import RowText from "../RowText";

import ColoredItem from "./ColoredItem";

interface ColoredTagsProps {
  data?: Array<{
    name?: string;
    color?: string;
    isCurrent?: boolean;
  }>;
  filterKey?: string;
  handler?: (params: { key: string; item: any }) => void;
  idx?: number;
}

const ColoredTags = ({ data, filterKey, handler, idx = 0 }: ColoredTagsProps) => {
  return (
    <>
      {data?.length ? (
        <Flex align={"center"} columnGap={"4px"}>
          {data?.map((item, index) =>
            item && (idx === 6 ? item?.isCurrent : true) ? (
              <ColoredItem
                key={`${item?.name || 'unnamed'}-${item?.color || 'nocolor'}-${index}`}
                item={item}
                handler={handler}
                filterKey={filterKey}
              />
            ) : null
          )}
        </Flex>
      ) : (
        <RowText text={""} idx={idx} />
      )}
    </>
  );
};

export default ColoredTags;
